@if (!show()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (show()) {
    <div class="price-group">
        <div class="price-column">
            <div class="price-line">Item</div>
            @for (priceItem of priceGroup().items.get(inspections()[0]); track priceItem.id) {
                @if (priceGroup().namesMap[priceItem?.decoration_id]) {
                    <div class="price-line">
                        {{priceGroup().namesMap[priceItem?.decoration_id]['name']}}
                    </div>
                }
                @if (priceGroup().namesMap[priceItem?.extra_cost_type_id]) {
                    <div class="price-line">
                        {{priceGroup().namesMap[priceItem?.extra_cost_type_id]['name']}}
                    </div>
                }
                @if (!priceGroup().namesMap[priceItem?.decoration_id] && priceGroup().namesMap[priceItem?.material_id]) {
                    <div class="price-line">
                        {{priceGroup().namesMap[priceItem?.material_id]['name']}}
                        {{priceItem?.paint_color_id ? paintColorKeyVal()[priceItem?.paint_color_id]['name'] : ''}}
                    </div>
                }
            }
        </div>
        @for (inspection of inspections(); track inspection.id) {
            <div class="price-column">
                <div class="price-line flex-column">
                    <small>{{inspection.customer_area?.name}}</small>
                    {{inspection.name}}
                </div>
                @for (priceItem of priceGroup().items.get(inspection); track priceItem; let i = $index) {
                    <div class="price-line">
                        <mat-form-field class="me-2">
                            <span matPrefix>€&nbsp;&nbsp;</span>
                            <input
                                [(ngModel)]="priceItem.price"
                                [disabled]="inspection.lock"
                                id="panel-{{panelIndex()}}-{{i}}"
                                matInput
                                min="0"
                                step="0.01"
                                type="number">
                            @if (priceItem?.extra_cost_type_id) {
                                <span matSuffix>{{extraCostNames()[priceItem['extra_cost_type_id']]['unit']}}</span>
                            }
                            @if (priceItem?.material_id && !priceItem?.decoration_id) {
                                <span matSuffix>m
                                    @if (priceItem.material_id !== 8) {
                                        <sup>2</sup>
                                    }
                                </span>
                            }
                            @if (priceItem?.decoration_id && priceItem.material_id !== 5) {
                                <span matSuffix>m</span>
                            }
                        </mat-form-field>
                        <mat-form-field>
                            <span matPrefix><i class="fa-regular fa-hashtag" matPrefix></i>&nbsp;&nbsp;</span>
                            <input [(ngModel)]="priceItem.code" [disabled]="inspection.lock" matInput type="text">
                        </mat-form-field>
                        <button (click)="openPriceLog(priceItem.id, priceGroup().type, inspection.id)" mat-icon-button tabindex="-1"><i class="fas fa-history"></i></button>
                    </div>
                }
            </div>
        }
    </div>
}
